import {
  AuthorizationPermission,
  AuthorizationRole,
  PermissionMatrix
} from '../types/Authorization.types';

export const AUTHORIZATION_PERMISSION_MATRIX: PermissionMatrix = {
  OWNER: [
    'aiSystems.view',
    'aiSystems.create',
    'aiSystems.delete',
    'aiSystems.requirementList.view',
    'aiSystems.requirementList.manage',
    'aiSystems.repository.view',
    'aiSystems.repository.manage',
    'aiSystems.documentation.view',
    'aiSystems.documentation.delete',
    'aiSystems.documentation.generate',
    'aiSystems.documentation.finalize',
    'aiSystems.monitoring.view',
    'aiSystems.monitoring.manage',
    'aiSystems.deployerMonitoring.view',
    'aiSystems.deployerMonitoring.manage'
  ],
  ADMIN: [
    'aiSystems.view',
    'aiSystems.create',
    'aiSystems.delete',
    'aiSystems.requirementList.view',
    'aiSystems.requirementList.manage',
    'aiSystems.repository.view',
    'aiSystems.repository.manage',
    'aiSystems.documentation.view',
    'aiSystems.documentation.delete',
    'aiSystems.documentation.generate',
    'aiSystems.documentation.finalize',
    'aiSystems.monitoring.view',
    'aiSystems.monitoring.manage',
    'aiSystems.deployerMonitoring.view',
    'aiSystems.deployerMonitoring.manage'
  ],
  EDITOR: [
    'aiSystems.view',
    'aiSystems.requirementList.view',
    'aiSystems.requirementList.manage',
    'aiSystems.repository.view',
    'aiSystems.repository.manage',
    'aiSystems.documentation.view',
    'aiSystems.documentation.delete',
    'aiSystems.documentation.generate',
    'aiSystems.monitoring.view',
    'aiSystems.deployerMonitoring.view',
    'aiSystems.deployerMonitoring.manage'
  ],
  VIEWER: [
    'aiSystems.view',
    'aiSystems.requirementList.view',
    'aiSystems.repository.view',
    'aiSystems.documentation.view',
    'aiSystems.monitoring.view',
    'aiSystems.deployerMonitoring.view'
  ]
};

export const DEFAULT_AUTHORIZATION_ROLE: AuthorizationRole = 'VIEWER';

export const hasPermissionByRole = (
  role: AuthorizationRole,
  permission: AuthorizationPermission
) => AUTHORIZATION_PERMISSION_MATRIX[role].includes(permission);
